var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PageWithLayout',[_c('div',{staticClass:"inner_section"},[_c('BoardList',{attrs:{"title":"포스트","dataList":_vm.viewModel.PostDataList,"paginationData":_vm.viewModel.paginationData,"itemRouteName":"PostDetail"},on:{"onClickBtn":_vm.onMorePage}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }